/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyNotificationChannel } from './CompanyNotificationChannel';
import {
    CompanyNotificationChannelFromJSON,
    CompanyNotificationChannelFromJSONTyped,
    CompanyNotificationChannelToJSON,
    CompanyNotificationChannelToJSONTyped,
} from './CompanyNotificationChannel';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListCompanyNotificationChannelsResponse
 */
export interface ListCompanyNotificationChannelsResponse {
    /**
     * 
     * @type {Array<CompanyNotificationChannel>}
     * @memberof ListCompanyNotificationChannelsResponse
     */
    data: Array<CompanyNotificationChannel>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListCompanyNotificationChannelsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListCompanyNotificationChannelsResponse interface.
 */
export function instanceOfListCompanyNotificationChannelsResponse(value: object): value is ListCompanyNotificationChannelsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListCompanyNotificationChannelsResponseFromJSON(json: any): ListCompanyNotificationChannelsResponse {
    return ListCompanyNotificationChannelsResponseFromJSONTyped(json, false);
}

export function ListCompanyNotificationChannelsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCompanyNotificationChannelsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CompanyNotificationChannelFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListCompanyNotificationChannelsResponseToJSON(json: any): ListCompanyNotificationChannelsResponse {
      return ListCompanyNotificationChannelsResponseToJSONTyped(json, false);
  }

  export function ListCompanyNotificationChannelsResponseToJSONTyped(value?: ListCompanyNotificationChannelsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(CompanyNotificationChannelToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

